"use strict";

$ = jQuery;

var done = false;
var offerID = "";

$(document).ready(function () {

  offerID = $(".jc-offer-header").attr('data-id');

  console.log('READY');
  watchCEP();

  $('#form-offer-' + offerID).on('DOMSubtreeModified', watchSecondStep);
});

// //Checa se o modal foi aberto e se o campo CEP foi criado para chamar o watchCEP
// $('.offer-form').bind('DOMSubtreeModified', function(){
//   var catchCEP = $('.offer-form').find('.cep').length;
//   if (!done && catchCEP > 0) {    //Garante que o watch irá rodar uma vez no modal atual
//     done = true;
//     offerID = $(".jc-offer-header").attr('data-id');
//     watchCEP();
//     $('#form-offer-' + offerID).on('DOMSubtreeModified', watchSecondStep);
//   }
// });

//Ativa o watchcep para o segundo passo
function watchSecondStep() {
  var offerID = $(".jc-offer-header").attr('data-id');
  var slug = $(".jc-offer-header").attr('data-slug');
  if ($('#form-offer-' + offerID).find(".form-offer-second").length > 0 && done === false) {
    $('#form-offer-' + offerID).off('DOMSubtreeModified');
    offerID = $(".jc-offer-header").attr('data-id');
    slug = $(".jc-offer-header").attr('data-slug');
    watchCEP();
  }
}

// //Possibilita que o watchCEP seja chamado novamente caso outro modal seja aberto
// $('#offer-form-modal').on('hidden.bs.modal', function (e) {
//   done = false;
// })

function watchCEP() {
  console.log("watchCEP");

  var cepElement = document.querySelector('input[name="cep"]');
  var cepLabel = $('.cep-label');
  var offerID = $(".jc-offer-header").attr('data-id');
  var slug = $(".jc-offer-header").attr('data-slug');

  if (cepLabel.text() !== "") {
    $('.jc-select-box').css('display', 'none');
    loadDealershipsByCep(offerID, cepElement.value, slug);
  }

  cepElement.addEventListener('keyup', function () {
    if (validateCep(cepElement.value)) {
      $('.jc-select-box').css('display', 'none');
      cepElement.blur();

      if (!cepElement.classList.contains('not_dealerships')) {
        loadDealershipsByCep(offerID, cepElement.value, slug);
      }
    } else {
      showAllDealershipsComponent();
    }
  });
}

function loadDealershipsByCep(offerID, cep, slug) {

  var divElement = document.getElementById("dont_cep");
  if (divElement) {
    divElement.remove();
  }

  var brand = '';
  var is_catalog = false;
  if (!offerID) {
    var is_catalog = $('#is-catalog-model-bradesco');
    if (is_catalog.length != 0) {
      brand = is_catalog.attr('data-brand');
      is_catalog = true;
    }
  }

  $.ajax({
    url: ajaxHandler.url_leads + '/api/jornaldocarro/v1/dealerships-cep',
    type: 'GET',
    data: {
      action: 'jc_ajax_load_dealerships_by_cep',
      offer: offerID,
      cep: cep,
      slug: slug,
      brand: brand,
      is_catalog: is_catalog
    },
    beforeSend: function beforeSend() {
      $('#loading').css('display', 'block');
      $('#response_message').text('Carregando...');
      $('.already-loaded-dealership-list').css('display', 'none');
      $('.load-dealership-list').empty();
      $('.dealerships').css('display', 'none');
    },
    success: function success(response) {

      if (response.data.length > 0) {
        response.data.forEach(function (dealership) {

          var addressFormat = dealership.endereco + " - " + dealership.bairro + ", " + dealership.cidade + " - " + dealership.estado + " " + (dealership.telefone !== "" ? " - Tel.: " + dealership.telefone : "") + " - DIST\xC2NCIA: " + dealership.distancia + " KM";
          var dealershipId = dealership.nome + ";" + dealership.marca + ";" + dealership.latitude + ";" + dealership.longitude;
          var bradescoValid = dealership.is_linked_bradesco == 1 ? 'true' : 'false';

          if (offerID == 295917) {

            if (dealership.estado == 'SP') {

              $('.load-dealership-list').append("<div class='radio mb-2 d-block' data-city='" + dealership.cidade + " - " + dealership.estado + "'>\n              <label class='custom-control custom-radio' for='dealership-" + dealershipId + "' bradesco-valid= " + bradescoValid + ">\n              <input type='radio' id='dealership-" + dealershipId + "' value='" + dealershipId + "' name='dealership' class='custom-control-input' style=\"opacity:1\">\n              <span class='custom-control-indicator'></span>\n              <span class='custom-control-description'>\n                <p class='h6 font-weight-bold text-uppercase mb-1'>" + dealership.nome + "</p>\n                <span>\n                  " + addressFormat + "\n                </span>\n              </span>\n              </label>\n              </div>");
            }
          } else {

            $('.load-dealership-list').append("<div class='radio mb-2 d-block' data-city='" + dealership.cidade + " - " + dealership.estado + "'>\n              <label class='custom-control custom-radio' for='dealership-" + dealershipId + "' bradesco-valid= " + bradescoValid + ">\n              <input type='radio' id='dealership-" + dealershipId + "' value='" + dealershipId + "' name='dealership' class='custom-control-input' style=\"opacity:1\">\n              <span class='custom-control-indicator'></span>\n              <span class='custom-control-description'>\n                <p class='h6 font-weight-bold text-uppercase mb-1'>" + dealership.nome + "</p>\n                <span>\n                  " + addressFormat + "\n                </span>\n              </span>\n              </label>\n              </div>");
          }
        });

        $('#loading').css('display', 'none');
        $('.load-dealership-list').css('display', 'block');
        $('.dealerships').css('display', 'block');
      } else {
        $('#dealership_form').before("<p class=\"small mb-0\" id=\"dont_cep\"><span style=\"color: red;\">N\xE3o encontramos lojas por este CEP, por favor selecione uma cidade</span></p>");
        showAllDealershipsComponent();
      }
    }
  });
}

function showAllDealershipsComponent() {
  $('.jc-select-box').css('display', 'block');
  $('.load-dealership-list').empty();
  $('.dealerships').css('display', 'none');
  $('.already-loaded-dealership-list').css('display', 'block');
  $('.city').prop("selectedIndex", 0).change();
  $('#loading').css('display', 'none');
}